(() => {
  if (window.ITPShareStudioReady) return;
  const studio = document.querySelector('[data-itp-share-studio]');
  if (!studio) return;
  window.ITPShareStudioReady = true;
  let text;
  try { text = JSON.parse(studio.querySelector('[data-share-translations]').textContent); } catch { return; }
  const canvas = studio.querySelector('[data-share-canvas]');
  const context = canvas.getContext('2d');
  const status = studio.querySelector('[data-share-studio-status]');
  const nativeButton = studio.querySelector('[data-share-native]');
  const download = studio.querySelector('[data-share-download]');
  const nativeLabel = studio.querySelector('[data-share-native-label]');
  const videoButton = studio.querySelector('[data-share-video]');
  const videoCancel = studio.querySelector('[data-share-video-cancel]');
  const videoDownload = studio.querySelector('[data-share-video-download]');
  const videoPreview = studio.querySelector('[data-share-video-preview]');
  const videoNote = studio.querySelector('[data-share-video-note]');
  const linkInput = studio.querySelector('[data-share-link]');
  const captionInput = studio.querySelector('[data-share-caption]');
  const formatButtons = Array.from(studio.querySelectorAll('[data-share-format]'));
  const colors = {"bronze":["#bf8961","#77482f"],"gold":["#d0ad67","#88672e"],"platinum":["#b8c7cc","#677f88"],"diamond":["#b9d8e2","#5e8b9c"],"neutral":["#d2b889","#33443b"]};
  // Canonical geometry: itp-award-master-v12.svg / work/v12/award-family.json.
  const awardFamilyV12 = {"paths":{"body":"M14 2H94L126 34V132L94 166H2V14Z","satin":"M16 7H92L121 36V130L92 161H7V16Z","enamel":"M20 17H87L111 41V126L87 151H17V20Z","inner":"M22 21H85L107 43V124L85 147H21V22Z","facets":["M27 107L56 94L70 108L40 122Z","M37 77L70 62L85 77L51 93Z","M48 45L84 28L101 46L64 63Z"],"edges":["M27 107L40 122L70 108L68 113L40 126L27 112Z","M37 77L51 93L85 77L83 82L51 97L37 82Z","M48 45L64 63L101 46L99 51L64 67L48 50Z"]},"materials":{"bronze":{"name":"Bronze","title":"Select","light":"#f1cfac","metal":"#bf8961","shade":"#77482f","ink":"#2b1c13"},"gold":{"name":"Gold","title":"Prestige","light":"#f6e6bd","metal":"#d0ad67","shade":"#88672e","ink":"#302611"},"platinum":{"name":"Platinum","title":"Signature","light":"#f3f7f7","metal":"#b8c7cc","shade":"#677f88","ink":"#21343a"},"diamond":{"name":"Diamant","title":"Ultimate","light":"#f1faff","metal":"#b9d8e2","shade":"#5e8b9c","ink":"#15303c"}}};
  const drawAwardV12 = (tier, x, y, width) => {
    const material = awardFamilyV12.materials[tier];
    if (!material) return;
    const geometry = awardFamilyV12.paths;
    const trace = d => {
      const tokens = d.match(/[A-Za-z]|-?\d*\.?\d+/g) || [];
      let position = 0, px = 0, py = 0;
      context.beginPath();
      while (position < tokens.length) {
        const command = tokens[position++];
        if (command === 'M' || command === 'L') {
          px = Number(tokens[position++]); py = Number(tokens[position++]);
          if (command === 'M') context.moveTo(px, py); else context.lineTo(px, py);
        } else if (command === 'H') { px = Number(tokens[position++]); context.lineTo(px, py); }
        else if (command === 'V') { py = Number(tokens[position++]); context.lineTo(px, py); }
        else if (command === 'Z') context.closePath();
      }
    };
    const gradient = (stops, x2 = 128, y2 = 168, x1 = 0, y1 = 0) => {
      const paint = context.createLinearGradient(x1, y1, x2, y2);
      stops.forEach(([offset, color]) => paint.addColorStop(offset, color));
      return paint;
    };
    const fill = (d, paint) => { trace(d); context.fillStyle = paint; context.fill(); };
    context.save();
    context.translate(x, y);
    context.scale(width / 128, width / 128);
    fill(geometry.body, gradient([[0,material.light],[.12,material.metal],[.46,material.shade],[.57,material.light],[1,material.shade]]));
    fill(geometry.satin, gradient([[0,material.shade],[.18,material.metal],[.52,material.light],[.78,material.metal],[1,material.shade]],128,25));
    fill(geometry.enamel, gradient([[0,'#153a30'],[.52,'#0a241d'],[1,'#041812']]));
    trace(geometry.inner); context.strokeStyle = material.light; context.globalAlpha = .2; context.lineWidth = .6; context.stroke(); context.globalAlpha = 1;
    geometry.edges.forEach(d => fill(d, material.shade));
    geometry.facets.forEach(d => {
      const numbers = d.match(/-?\d*\.?\d+/g).map(Number);
      const xs = numbers.filter((_,i) => i % 2 === 0), ys = numbers.filter((_,i) => i % 2 === 1);
      const left = Math.min(...xs), top = Math.min(...ys), right = Math.max(...xs), bottom = Math.max(...ys);
      fill(d, gradient([[0,material.light],[.48,material.metal],[1,material.shade]], left + (right-left)*.8, bottom, left, top));
    });
    context.restore();
  };
  const interpolate = (value, data) => String(value || '').replace(/\{(\w+)\}/g, (_, key) => data[key] ?? '');
  const trim = (value, max = 180) => String(value || '').replace(/\s+/g, ' ').trim().slice(0, max);
  let details;
  let format = 'story';
  let currentFile;
  let currentObjectURL;
  let imageFile;
  let videoObjectURL;
  let recording;
  let trigger;
  let generation = 0;
  const safeLink = value => {
    try {
      const url = new URL(value || window.location.href, window.location.href);
      if (url.origin !== window.location.origin || !['https:', 'http:'].includes(url.protocol)) return window.location.origin;
      const preserved = new URLSearchParams();
      const view = url.searchParams.get('view');
      if (['achievement-profile', 'achievement-list', 'achievement-category', 'honours-profile'].includes(view)) {
        preserved.set('view', view);
        if (view === 'honours-profile') {
          const person = url.searchParams.get('person');
          if (/^(?:[1-9]|1[0-9]|2[01])$/.test(person || '')) preserved.set('person', person);
        }
        for (const name of ['list', 'rank', 'rank_page', 'category']) {
          const value = url.searchParams.get(name);
          if (value && /^[a-z0-9-]{1,48}$/i.test(value)) preserved.set(name, value);
        }
      }
      url.username = '';
      url.password = '';
      url.search = preserved.toString();
      url.hash = '';
      return url.href;
    } catch { return window.location.origin; }
  };
  const loadImage = value => new Promise(resolve => {
    if (!value) { resolve(null); return; }
    let url;
    try {
      url = new URL(value, document.baseURI);
      if (!['https:', 'http:'].includes(url.protocol) || (url.origin !== window.location.origin && url.hostname !== 'cdn.shopify.com' && !url.hostname.endsWith('.myshopify.com'))) { resolve(null); return; }
    } catch { resolve(null); return; }
    const image = new Image();
    const timeout = window.setTimeout(() => { image.onload = null; image.onerror = null; resolve(null); }, 9000);
    image.crossOrigin = 'anonymous';
    image.onload = () => { window.clearTimeout(timeout); resolve(image.naturalWidth ? image : null); };
    image.onerror = () => { window.clearTimeout(timeout); resolve(null); };
    image.src = url.href;
  });
  const spaced = (value, x, y, spacing = 4) => {
    const letters = Array.from(value);
    for (const letter of letters) {
      context.fillText(letter, x, y);
      x += context.measureText(letter).width + spacing;
    }
  };
  const lines = (value, maxWidth) => {
    const words = trim(value, 350).split(' ');
    const output = [];
    let line = '';
    words.forEach(token => {
      let word = token;
      const candidate = line ? `${line} ${word}` : word;
      if (context.measureText(candidate).width <= maxWidth) { line = candidate; return; }
      if (line) { output.push(line); line = ''; }
      while (word && context.measureText(word).width > maxWidth) {
        let count = 1;
        while (count < word.length && context.measureText(word.slice(0, count + 1)).width <= maxWidth) count += 1;
        output.push(word.slice(0, count));
        word = word.slice(count);
      }
      line = word;
    });
    if (line) output.push(line);
    return output;
  };
  const drawText = (value, x, y, width, fontSize, maxLines = 2, serif = true, color = '#f5ecd8', anchor = 'baseline') => {
    let size = fontSize;
    let output;
    const minimum = Math.min(22, fontSize);
    while (true) {
      context.font = `400 ${size}px ${serif ? 'Georgia, serif' : 'Arial, sans-serif'}`;
      output = lines(value, width);
      if (output.length <= maxLines || size <= minimum) break;
      size = Math.max(minimum, size - 2);
    }
    if (output.length > maxLines) {
      output = output.slice(0, maxLines);
      let last = output[output.length - 1];
      while (last && context.measureText(`${last}…`).width > width) last = last.slice(0, -1);
      output[output.length - 1] = `${last}…`;
    }
    context.fillStyle = color;
    const ascent = Math.max(...output.map(line => context.measureText(line).actualBoundingBoxAscent || size * .8), size * .8);
    const baseline = anchor === 'top' ? y + ascent : y;
    output.forEach((line, index) => context.fillText(line, x, baseline + index * size * 1.16));
    return output.length * size * 1.16;
  };
  const paint = (image, item) => {
    const height = format === 'story' ? 1920 : 1350;
    canvas.width = 1080;
    canvas.height = height;
    const [metal, shadow] = colors[item.tier] || colors.neutral;
    const background = context.createLinearGradient(0, 0, 1080, height);
    background.addColorStop(0, '#071b17');
    background.addColorStop(.55, '#0c241e');
    background.addColorStop(1, '#071b17');
    context.fillStyle = background;
    context.fillRect(0, 0, 1080, height);
    const glow = context.createRadialGradient(830, 280, 0, 830, 280, 900);
    glow.addColorStop(0, shadow + '55');
    glow.addColorStop(1, shadow + '00');
    context.fillStyle = glow;
    context.fillRect(0, 0, 1080, height);
    context.strokeStyle = metal + '88';
    context.lineWidth = 1.5;
    context.strokeRect(38, 38, 1004, height - 76);
    context.strokeStyle = metal + '35';
    context.strokeRect(49, 49, 982, height - 98);
    context.font = '400 47px Georgia, serif';
    context.fillStyle = '#f0e6cd';
    context.save();
    if (format === 'story') context.translate(0, 150);
    spaced('INTHATPACK', 82, 121, 7);
    context.font = '400 17px Arial, sans-serif';
    context.fillStyle = metal;
    spaced(text.brand_line, 85, 156, 3);
    if (item.demo) {
      context.fillStyle = '#d2b587';
      context.fillRect(82, 182, 916, 43);
      context.fillStyle = '#152017';
      context.font = '700 17px Arial, sans-serif';
      spaced(text.example, 101, 209, 1.4);
    }
    context.restore();
    const imageY = (item.demo ? 252 : 217) + (format === 'story' ? 150 : 0);
    const imageHeight = format === 'story' ? 560 : item.type === 'rank' ? 340 : 405;
    const photoPanel = (photo, x, y, width, height, entry) => {
      context.save();
      context.beginPath();
      context.rect(x, y, width, height);
      context.clip();
      if (photo) {
        const scale = Math.max(width / photo.naturalWidth, height / photo.naturalHeight);
        const photoWidth = photo.naturalWidth * scale;
        const photoHeight = photo.naturalHeight * scale;
        context.drawImage(photo, x + (width - photoWidth) / 2, y + (height - photoHeight) * .36, photoWidth, photoHeight);
      } else {
        const panel = context.createLinearGradient(x, y, x + width, y + height);
        panel.addColorStop(0, '#293528');
        panel.addColorStop(1, '#101910');
        context.fillStyle = panel;
        context.fillRect(x, y, width, height);
        context.font = `italic ${Math.min(width, height) * .36}px Georgia, serif`;
        context.fillStyle = metal;
        const initials = item.name.split(' ').filter(Boolean).slice(0, 2).map(part => part[0]).join('') || 'I';
        context.textAlign = 'center';
        context.fillText(initials, x + width / 2, y + height * .57);
        context.textAlign = 'left';
      }
      const shade = context.createLinearGradient(0, y + height * .35, 0, y + height);
      shade.addColorStop(0, '#10181000');
      shade.addColorStop(1, '#101810ee');
      context.fillStyle = shade;
      context.fillRect(x, y, width, height);
      if (entry) {
        const tileMetal = colors[entry.tier]?.[0] || metal;
        drawText(entry.title, x + 22, y + height - 52, width - 44, width > 500 ? 32 : 26, 1, true, '#fff1db');
        drawText(text[`metal_${entry.tier}`] || '', x + 22, y + height - 23, width - 44, 17, 1, false, tileMetal);
      } else {
        context.font = '400 20px Arial, sans-serif';
        context.fillStyle = '#f4ead7';
        spaced(trim(item.category || text[item.type], 40).toUpperCase(), x + 33, y + height - 30, 2);
      }
      context.restore();
    };
    if (item.type === 'collection' && item.collection.length) {
      const gap = 8;
      const halfWidth = (916 - gap) / 2;
      const halfHeight = (imageHeight - gap) / 2;
      item.collection.forEach((entry, index) => {
        let box;
        if (item.collection.length === 1) box = [82, imageY, 916, imageHeight];
        else if (item.collection.length === 2) box = [82 + index * (halfWidth + gap), imageY, halfWidth, imageHeight];
        else if (item.collection.length === 3 && index === 0) box = [82, imageY, 916, halfHeight];
        else if (item.collection.length === 3) box = [82 + (index - 1) * (halfWidth + gap), imageY + halfHeight + gap, halfWidth, halfHeight];
        else box = [82 + (index % 2) * (halfWidth + gap), imageY + Math.floor(index / 2) * (halfHeight + gap), halfWidth, halfHeight];
        photoPanel(item.collectionImages[index], ...box, entry);
      });
    } else photoPanel(image, 82, imageY, 916, imageHeight);
    context.strokeStyle = metal + '66';
    context.strokeRect(82, imageY, 916, imageHeight);
    const top = imageY + imageHeight + 48;
    context.font = '400 18px Arial, sans-serif';
    context.fillStyle = metal;
    spaced(text[item.type] || text.profile, 84, top, 3);
    let cursor = top + 36;
    if (item.type === 'rank') {
      cursor += drawText(interpolate(text.position, { rank: item.rank }), 80, cursor, 916, format === 'story' ? 132 : 106, 1, true, '#f5ecd8', 'top');
      cursor += 16;
      cursor += drawText(item.name, 84, cursor, 916, 43, 1, true, '#f5ecd8', 'top');
      drawText(item.title, 84, cursor + 14, 916, 27, 2, false, '#d4ccb5', 'top');
    } else if (item.type === 'achievement') {
      cursor += drawText(item.title, 80, cursor, 916, format === 'story' ? 77 : 65, format === 'story' ? 3 : 2, true, '#f5ecd8', 'top');
      drawText(item.name, 84, cursor + 18, 916, 31, 1, false, '#d4ccb5', 'top');
    } else if (item.type === 'collection') {
      cursor += drawText(item.name, 80, cursor, 916, format === 'story' ? 82 : 52, 2, true, '#f5ecd8', 'top');
      const countLine = interpolate(text.count, { count: item.count });
      const subtitle = item.count > item.collection.length ? `${countLine} · ${interpolate(text.selection, { count: item.collection.length })}` : countLine;
      cursor += 16;
      cursor += drawText(subtitle, 84, cursor, 916, 27, 1, false, '#d4ccb5', 'top');
      cursor += 16;
      ['bronze', 'gold', 'platinum', 'diamond'].forEach((tier, index) => {
        const x = 84 + index * 229;
        const tierMetal = colors[tier][0];
        drawAwardV12(tier, x, cursor + 2, format === 'story' ? 32 : 26);
        drawText(String(item.counts[tier] || 0), x + 43, cursor, 152, format === 'story' ? 34 : 28, 1, true, tierMetal, 'top');
        drawText((text[`metal_${tier}`] || tier).split(' · ')[0].toUpperCase(), x, cursor + (format === 'story' ? 48 : 40), 195, 17, 1, false, tierMetal, 'top');
      });
    } else {
      cursor += drawText(item.name, 80, cursor, 916, format === 'story' ? 92 : 72, 2, true, '#f5ecd8', 'top');
      const subtitle = item.count > 0 ? interpolate(text.count, { count: item.count }) : item.category;
      drawText(subtitle, 84, cursor + 18, 916, 29, 1, false, '#d4ccb5', 'top');
    }
    const badgeY = height - (format === 'story' ? 430 : 330);
    if (item.tier) {
      const badge = context.createLinearGradient(82, badgeY, 998, badgeY + 110);
      badge.addColorStop(0, shadow + '60');
      badge.addColorStop(1, shadow + '10');
      context.fillStyle = badge;
      context.fillRect(82, badgeY, 916, 110);
      context.strokeStyle = metal + '88';
      context.strokeRect(82, badgeY, 916, 110);
      drawAwardV12(item.tier, 108, badgeY + 13, 64);
      const awardNames = String(text[`metal_${item.tier}`] || '').split(' · ');
      drawText(awardNames[0].toUpperCase(), 202, badgeY + 47, 755, 27, 1, false, metal);
      drawText(awardNames.slice(1).join(' · '), 202, badgeY + 80, 755, 21, 1, false, '#d6dfd8');
    }
    if (item.date) drawText(interpolate(text.as_of, { date: item.date }), 85, badgeY - 22, 916, 21, 1, false, '#b8b7a4');
    const printableURL = item.url.replace(/^https?:\/\//, '').replace(/^www\./, '');
    drawText(printableURL, 85, height - (format === 'story' ? 270 : 160), 910, 19, format === 'story' ? 1 : 2, false, '#c7c8b7');
    context.font = '400 14px Arial, sans-serif';
    context.fillStyle = metal;
    spaced('INTHATPACK.COM', 85, height - 79, 3);
    if (item.demo) {
      context.textAlign = 'right';
      context.font = '700 18px Arial, sans-serif';
      context.fillStyle = '#e9c68b';
      context.fillText(text.example_short, 998, height - 79);
      context.textAlign = 'left';
    }
  };
  const createBlob = () => new Promise((resolve, reject) => {
    try { canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('Empty image')), 'image/png'); } catch (error) { reject(error); }
  });
  const mp4Type = () => {
    if (!videoButton || typeof canvas.captureStream !== 'function' || typeof window.MediaRecorder !== 'function' || window.isSecureContext === false) return '';
    try { return ['video/mp4;codecs=avc1.424028', 'video/mp4;codecs=avc1.42E028', 'video/mp4;codecs=avc1', 'video/mp4'].find(type => window.MediaRecorder.isTypeSupported(type)) || ''; } catch { return ''; }
  };
  const updateNative = () => {
    let supported = false;
    try { supported = Boolean(currentFile && navigator.share && navigator.canShare?.({ files: [currentFile] })); } catch {}
    nativeButton.disabled = Boolean(recording) || !supported;
    if (nativeLabel) nativeLabel.textContent = currentFile?.type === 'video/mp4' ? text.native_video : text.native;
    studio.querySelector('[data-share-file-fallback]').hidden = supported || Boolean(recording);
  };
  const clearVideo = () => {
    studio.dataset.videoReady = 'false';
    if (videoPreview) {
      videoPreview.pause();
      videoPreview.removeAttribute('src');
      videoPreview.load();
      videoPreview.hidden = true;
    }
    canvas.hidden = false;
    if (videoObjectURL) URL.revokeObjectURL(videoObjectURL);
    videoObjectURL = null;
    if (videoDownload) { videoDownload.hidden = true; videoDownload.removeAttribute('href'); }
  };
  const videoBusy = busy => {
    studio.dataset.recording = String(busy);
    formatButtons.forEach(button => { button.disabled = busy; });
    if (videoButton) videoButton.disabled = busy || !imageFile || !mp4Type();
    if (videoCancel) videoCancel.hidden = !busy;
    if (busy) download.setAttribute('aria-disabled', 'true');
    else if (currentObjectURL) download.removeAttribute('aria-disabled');
    updateNative();
  };
  const releaseRecording = job => {
    window.cancelAnimationFrame(job.frame);
    window.clearTimeout(job.timer);
    window.clearTimeout(job.guard);
    job.stream?.getTracks().forEach(track => track.stop());
  };
  const cancelRecording = message => {
    const job = recording;
    if (!job) return;
    job.cancelled = true;
    job.recorder.ondataavailable = null;
    job.recorder.onstop = null;
    job.recorder.onerror = null;
    try { if (job.recorder.state !== 'inactive') job.recorder.stop(); } catch {}
    releaseRecording(job);
    if (context && job.snapshot) context.drawImage(job.snapshot, 0, 0);
    recording = null;
    currentFile = imageFile;
    videoBusy(false);
    if (message) status.textContent = message;
  };
  const createVideo = () => {
    const mimeType = mp4Type();
    if (recording || !imageFile || !mimeType) return;
    if (document.hidden) { status.textContent = text.video_interrupted; return; }
    clearVideo();
    currentFile = imageFile;
    const snapshot = document.createElement('canvas');
    snapshot.width = canvas.width;
    snapshot.height = canvas.height;
    snapshot.getContext('2d').drawImage(canvas, 0, 0);
    let stream;
    try {
      stream = canvas.captureStream(30);
      const recorder = new window.MediaRecorder(stream, { mimeType, videoBitsPerSecond: 6000000 });
      const job = { recorder, stream, snapshot, chunks: [], cancelled: false, frame: 0, timer: 0, guard: 0, generation, started: 0, remaining: 0, finishing: false };
      recording = job;
      videoBusy(true);
      const finish = () => {
        if (recording !== job || job.cancelled || job.finishing) return;
        job.finishing = true;
        window.cancelAnimationFrame(job.frame);
        window.clearTimeout(job.timer);
        status.textContent = text.video_finishing;
        job.guard = window.setTimeout(() => { if (recording === job) cancelRecording(text.video_error); }, 8000);
        try { recorder.stop(); } catch { cancelRecording(text.video_error); }
      };
      const frame = timestamp => {
        if (recording !== job || job.cancelled || job.finishing) return;
        if (document.hidden || !studio.open) { cancelRecording(text.video_interrupted); return; }
        const progress = Math.min(1, Math.max(0, (timestamp - job.started) / 6000));
        context.drawImage(snapshot, 0, 0);
        context.save();
        context.globalCompositeOperation = 'screen';
        const x = -canvas.width * 1.5 + progress * canvas.width * 3.7;
        const light = context.createLinearGradient(x, 0, x + canvas.width * .8, canvas.height);
        light.addColorStop(0, '#fff6db00');
        light.addColorStop(.38, '#fff6db00');
        light.addColorStop(.5, '#fff3c54a');
        light.addColorStop(.62, '#fff6db00');
        light.addColorStop(1, '#fff6db00');
        context.fillStyle = light;
        context.fillRect(38, 38, canvas.width - 76, canvas.height - 76);
        context.restore();
        const remaining = Math.max(1, Math.ceil(6 * (1 - progress)));
        if (remaining !== job.remaining) { job.remaining = remaining; status.textContent = interpolate(text.video_busy, { seconds: remaining }); }
        if (progress >= 1) finish();
        else job.frame = window.requestAnimationFrame(frame);
      };
      recorder.ondataavailable = event => { if (event.data?.size > 0 && !job.cancelled) job.chunks.push(event.data); };
      recorder.onerror = () => { if (recording === job) cancelRecording(text.video_error); };
      recorder.onstop = async () => {
        releaseRecording(job);
        if (recording !== job || job.cancelled || job.generation !== generation) return;
        try {
          if (!recorder.mimeType.toLowerCase().startsWith('video/mp4') || job.chunks.some(chunk => chunk.type && !chunk.type.toLowerCase().startsWith('video/mp4'))) throw new Error('MP4 encoding unavailable');
          const blob = new Blob(job.chunks, { type: 'video/mp4' });
          if (blob.size < 1000 || await blob.slice(4, 8).text() !== 'ftyp') throw new Error('Invalid MP4 file');
          if (recording !== job || job.cancelled || job.generation !== generation) return;
          const filename = imageFile.name.replace(/\.png$/i, '-6s.mp4');
          currentFile = new File([blob], filename, { type: 'video/mp4' });
          videoObjectURL = URL.createObjectURL(blob);
          videoDownload.href = videoObjectURL;
          videoDownload.download = filename;
          videoDownload.hidden = false;
          context.drawImage(snapshot, 0, 0);
          recording = null;
          videoBusy(false);
          status.textContent = text.video_ready;
          if (videoPreview) {
            videoPreview.width = canvas.width;
            videoPreview.height = canvas.height;
            studio.dataset.videoReady = 'true';
            videoPreview.src = videoObjectURL;
            videoPreview.hidden = false;
            canvas.hidden = true;
            const playing = videoPreview.play();
            if (playing?.catch) playing.catch(() => {});
          }
        } catch { if (recording === job) cancelRecording(text.video_error); }
      };
      recorder.start(250);
      job.started = window.performance.now();
      frame(job.started);
      job.timer = window.setTimeout(finish, 6000);
    } catch {
      if (recording) cancelRecording(text.video_error);
      else { stream?.getTracks().forEach(track => track.stop()); videoBusy(false); status.textContent = text.video_error; }
    }
  };
  const render = async () => {
    cancelRecording();
    clearVideo();
    imageFile = null;
    if (videoButton) videoButton.disabled = true;
    if (videoNote) videoNote.textContent = mp4Type() ? text.video_help : text.video_unavailable;
    const attempt = ++generation;
    const item = { ...details };
    currentFile = null;
    nativeButton.disabled = true;
    download.removeAttribute('href');
    download.setAttribute('aria-disabled', 'true');
    status.textContent = text.loading;
    studio.querySelector('[data-share-frame]').dataset.format = format;
    studio.querySelector('[data-share-dimensions]').textContent = format === 'story' ? '1080 × 1920' : '1080 × 1350';
    formatButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.shareFormat === format)));
    try {
      if (!context) throw new Error('Canvas unavailable');
      const [image, collectionImages] = await Promise.all([loadImage(item.image), Promise.all(item.collection.map(entry => loadImage(entry.image)))]);
      if (attempt !== generation) return;
      item.collectionImages = collectionImages;
      paint(image, item);
      const blob = await createBlob();
      if (attempt !== generation) return;
      if (currentObjectURL) URL.revokeObjectURL(currentObjectURL);
      currentObjectURL = URL.createObjectURL(blob);
      const filename = `INTHATPACK-${item.type}-${item.name.replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '').slice(0, 60) || 'card'}-${format}.png`;
      imageFile = typeof File === 'function' ? new File([blob], filename, { type: 'image/png' }) : null;
      currentFile = imageFile;
      download.href = currentObjectURL;
      download.download = filename;
      download.removeAttribute('aria-disabled');
      updateNative();
      if (videoButton) videoButton.disabled = !imageFile || !mp4Type();
      const missingImage = item.type === 'collection' && item.collection.length ? item.collection.some((entry, index) => entry.image && !collectionImages[index]) : item.image && !image;
      status.textContent = missingImage ? text.image_fallback : text.ready;
    } catch {
      if (attempt !== generation) return;
      status.textContent = text.error;
      studio.querySelector('[data-share-file-fallback]').hidden = false;
    }
  };
  const open = button => {
    trigger = button;
    const source = button.dataset;
    const rank = Number.parseInt(source.shareRank, 10);
    const tierValue = trim(source.shareTier, 30).toLowerCase();
    const aliases = { select: 'bronze', brons: 'bronze', prestige: 'gold', goud: 'gold', signature: 'platinum', platina: 'platinum', ultimate: 'diamond', diamant: 'diamond' };
    const tier = aliases[tierValue] || tierValue;
    details = {
      type: ['profile', 'achievement', 'rank', 'collection'].includes(source.itpShare) ? source.itpShare : 'profile',
      title: trim(source.shareTitle), name: trim(source.shareName, 90) || 'INTHATPACK', category: trim(source.shareCategory, 90),
      tier: Object.hasOwn(colors, tier) && tier !== 'neutral' ? tier : '',
      image: source.shareImage || '', url: safeLink(source.shareUrl), demo: source.shareDemo === 'true',
      rank: Number.isInteger(rank) && rank > 0 && rank < 10000000 ? rank : null,
      date: trim(source.shareDate, 30), count: Math.min(10000, Math.max(0, Number.parseInt(source.shareCount, 10) || 0))
    };
    details.collection = [];
    details.counts = {};
    const portfolio = button.closest('[data-public-profile], [data-demo-profile]');
    if (details.type === 'collection' && portfolio) {
      details.collection = Array.from(portfolio.querySelectorAll('[data-itp-share="achievement"]')).slice(0, 4).map(award => ({
        title: trim(award.dataset.shareTitle, 100), image: award.dataset.shareImage || '', tier: award.dataset.shareTier || ''
      }));
      portfolio.querySelectorAll('[data-profile-levels] > [data-tier]').forEach(level => {
        const key = level.dataset.tier;
        if (Object.hasOwn(colors, key)) details.counts[key] = Math.max(0, Number.parseInt(level.querySelector('.profile-v5__level-count')?.textContent, 10) || 0);
      });
    }
    if (details.type === 'collection' && !details.collection.length) details.type = 'profile';
    if (details.type === 'rank' && (!details.rank || (!details.demo && !details.date))) details.type = 'achievement';
    const caption = interpolate(text[`caption_${details.type}`], { ...details, tier: text[`metal_${details.tier}`] || '' });
    captionInput.value = [details.demo ? text.caption_example : '', caption, details.date ? interpolate(text.as_of, { date: details.date }) : '', details.url, '#INTHATPACK'].filter(Boolean).join('\n\n');
    canvas.setAttribute('aria-label', [details.demo ? text.example : '', text[details.type], details.name, details.type === 'rank' ? interpolate(text.position, { rank: details.rank }) : details.title, details.category, text[`metal_${details.tier}`], details.date].filter(Boolean).join(' · '));
    linkInput.value = details.url;
    if (typeof studio.showModal === 'function') {
      if (!studio.open) studio.showModal();
    } else studio.setAttribute('open', '');
    document.body.classList.add('itp-share-open');
    studio.querySelector('[data-share-close]').focus({ preventScroll: true });
    render();
  };
  const close = () => {
    generation += 1;
    cancelRecording();
    clearVideo();
    if (currentObjectURL) URL.revokeObjectURL(currentObjectURL);
    currentObjectURL = null;
    imageFile = null;
    currentFile = null;
    download.removeAttribute('href');
    if (typeof studio.close === 'function') studio.close();
    else studio.removeAttribute('open');
    document.body.classList.remove('itp-share-open');
    trigger?.focus({ preventScroll: true });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-itp-share]');
    if (!button) return;
    event.preventDefault();
    open(button);
  });
  studio.addEventListener('click', async event => {
    if (event.target.closest('[data-share-close]')) { close(); return; }
    if (event.target.closest('[data-share-video-cancel]')) { cancelRecording(text.video_cancelled); return; }
    if (event.target.closest('[data-share-video]')) { createVideo(); return; }
    if (event.target.closest('[data-share-video-download]')) {
      if (recording || !videoObjectURL) event.preventDefault();
      else status.textContent = text.video_ready;
      return;
    }
    const formatButton = event.target.closest('[data-share-format]');
    if (formatButton) {
      if (recording) return;
      if (format !== formatButton.dataset.shareFormat) { format = formatButton.dataset.shareFormat; render(); }
      return;
    }
    if (event.target.closest('[data-share-native]')) {
      if (!currentFile || nativeButton.disabled) return;
      try {
        await navigator.share({ files: [currentFile], title: `INTHATPACK · ${details.name}`, text: captionInput.value, url: details.url });
        status.textContent = text.share_opened;
      } catch (error) { if (error.name !== 'AbortError') status.textContent = text.share_failed; }
      return;
    }
    if (event.target.closest('[data-share-download]')) {
      if (!download.href || download.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
      status.textContent = text.downloaded;
      return;
    }
    const copy = event.target.closest('[data-share-copy]');
    if (copy) {
      const input = copy.dataset.shareCopy === 'link' ? linkInput : captionInput;
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(input.value);
        status.textContent = text.copied;
      } catch { input.focus(); input.select(); status.textContent = text.copy_manual; }
    }
    if (event.target === studio) {
      const box = studio.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
    }
  });
  studio.addEventListener('cancel', event => { event.preventDefault(); close(); });
  studio.addEventListener('close', () => { cancelRecording(); clearVideo(); document.body.classList.remove('itp-share-open'); });
  document.addEventListener('visibilitychange', () => { if (document.hidden) { if (recording) cancelRecording(text.video_interrupted); videoPreview?.pause(); } });
  window.addEventListener('pagehide', () => { cancelRecording(); clearVideo(); if (currentObjectURL) URL.revokeObjectURL(currentObjectURL); });
})();

